module.exports = __webpack_public_path__ + "static/media/Bryan_B@3x.b4f14fb9.jpg";